import { render, staticRenderFns } from "./PricingFAQ.vue?vue&type=template&id=0317b442&"
import script from "./PricingFAQ.vue?vue&type=script&lang=js&"
export * from "./PricingFAQ.vue?vue&type=script&lang=js&"
import style0 from "./PricingFAQ.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports